import { DataBean } from "../DataBean";

export class GuideItemList extends DataBean {

    public async addTransportGuideItemList(idTransportGuide: any, transportGuideDate: any, itemList: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_addTransportGuideItemList_Number_java.util.Date_java.util.List_Number", [idTransportGuide, transportGuideDate, itemList, idEmployee]);
    }

}